<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <dx-data-grid ref='refPressingCount'
      :data-source='pressingCountInfo'
      :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
      :hover-state-enabled = "true" :allowColumnResizing = 'true'
      column-resizing-mode = 'widget' :allow-column-reordering = "true"
      :row-alternation-enabled="true"
      :focused-row-enabled="false"
      :auto-navigate-to-focused-row="false"
      :height='gridHeight'
      @toolbar-preparing='onToolbarPreparing'
    >
      <DxSearchPanel
        :visible="true"
        placeholder="검색..."
      />
      <DxExport
        :enabled="false"
        :file-name="excelFileName"
      />
      <DxFilterRow
        :visible="true"
        apply-filter="auto"
      />
      <DxEditing
        :allow-deleting="false"
        :allow-updating="false"
        :allow-adding="false"
        :use-icons="true"
        mode='row'
      />
      <DxColumn
        :allowEditing='false'
        caption="생산일"
        data-field="발생일자"
        dataType='date'
        format='yyyy-MM-dd'>
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="업체코드(M1440)"
        data-field="업체코드"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="품번"
        data-field="품번"
      >
      </DxColumn>
       <DxColumn
        :allowEditing='false'
        caption="수량"
        data-field="수량"
        :visible='true'
        dataType="number"
        format='#,##0'
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="마감처계열"
        data-field="본사코드"
        :visible='true'
         sort-order='asc'
      >
          <DxLookup
          :data-source="customerGroupLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="마감처명"
        data-field="납품처코드"
        :visible='true'
      >
          <DxLookup
          :data-source="customerLookup"
          display-expr="거래처명"
          value-expr="거래처코드"
        />
      </DxColumn>
      <DxColumn v-if="isPurchase()"
        :allowEditing='false'
        caption="거래처명"
        data-field="입고업체"
        :visible='true'
      >
          <DxLookup
          :data-source="partnerLookup"
          display-expr="거래처명"
          value-expr="거래처코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="차종"
        data-field="차종"
      >
      </DxColumn>
      <DxColumn v-if="isPurchase()"
        :allowEditing='false'
        caption="자재유형"
        data-field="자재유형"
        :visible='true'
      >
        <DxLookup
          :data-source="materialTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
       <DxColumn v-if="isProduct()"
        :allowEditing='false'
        caption="공정유형"
        data-field="공정유형"
        :visible='true'
      >
        <DxLookup
          :data-source="processingTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <dx-paging :enabled="false"/>
      <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
      <dx-sorting mode="multiple"/>
    </dx-data-grid>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxLookup, DxEditing,
  DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport } from 'devextreme-vue/data-grid'
export default {
  name: 'pressDiePressingCount',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      searchDate: null,
      pressingCountInfo: null,
      excelFileName: '금형타수',
      materialTypeLookup: null,
      processingTypeLookup: null,
      partnerLookup: null,
      customerLookup: null,
      customerGroupLookup: null
    }
  },
  props: {
    goodsType: {
      type: String,
      default: 'S0106'
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxEditing,
    DxLookup
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.searchDate = `${AppLib.calcMonthFromToday(-1).substring(0, 7)}-01`
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.materialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.customerGroupLookup = this.$store.getters.getBaseDataByType(ConstDef.거래처그룹)
    this.refreshPressingCount(this.goodsType)
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    isPurchase () {
      return this.goodsType === ConstDef.구매품
    },
    isProduct () {
      console.log(this.goodsType)
      return this.goodsType === ConstDef.다공정품
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>기준월:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 80,
            value: this.searchDate,
            type: 'date',
            calendarOptions: {
              maxZoomLevel: 'year',
              minZoomLevel: 'century'
            },
            displayFormat: 'yyyy-MM',
            onInitialized: (args) => {
              this.rawMaterialsClosedRegDateBox = args.component
            },
            onValueChanged: (args) => {
              this.searchDate = args.value
              this.refreshPressingCount(this.goodsType)
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '엑셀저장',
            icon: 'xlsxfile',
            focusStateEnabled: true,
            onClick: (args) => {
              let title = '외주품'
              let groupCode = ''
              if (this.goodsType === ConstDef.다공정품) {
                title = '자작품'
              }
              const filter = this.$refs.refPressingCount.instance.getCombinedFilter()
              if (filter === undefined) {
                this.excelFileName = `${title} 금형타수(전체)`
              } else {
                if (typeof (filter[2]) === 'string') {
                  if (filter[2].indexOf(ConstDef.거래처그룹) >= 0) {
                    groupCode = this.$_.findWhere(this.customerGroupLookup, { 코드: filter[2] }).코드명
                    this.excelFileName = `${title} 금형타수(${groupCode})`
                  } else {
                    this.excelFileName = `${title} 금형타수()`
                  }
                } else {
                  filter.forEach(item => {
                    console.log(item)
                    if (item.columnIndex === 4) {
                      groupCode = this.$_.findWhere(this.customerGroupLookup, { 코드: item.filterValue }).코드명
                      this.excelFileName = `${title} 금형타수(${groupCode})`
                      console.log(item.filterValue)
                    } else {
                      this.excelFileName = `${title} 금형타수()`
                    }
                  })
                }
              }
              setTimeout(() => {
                this.$refs.refPressingCount.instance.exportToExcel(false)
              }, 0)
            }
          }
        }
      )
    },
    refreshPressingCount (goodsType) {
      this.isLoading = true

      const param = {
        fromDate: this.searchDate,
        toDate: `${AppLib.getMonthLastDateByDate(this.searchDate)} 23:59:59`,
        품목유형: goodsType

      }
      console.log(param)
      this.$_sp.runNoEncodeFindProc('spFindAllPressingCountByGoodsType', param)
        .then(data => {
          this.isLoading = false
          this.pressingCountInfo = this.$_sp.MakeModel(data)
          this.customerLookup = AppLib.getGroupByLookupCompany(this.$_, this.pressingCountInfo, '납품처코드', this.$store.getters.getFirstVendor)
          this.partnerLookup = AppLib.getGroupByLookupCompany(this.$_, this.pressingCountInfo, '입고업체', this.$store.getters.getPartnersInfo)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
